export { default as PolicyEditor } from './PolicyEditor';
